import { useState, useRef } from "react";
import { ref, uploadBytes, deleteObject } from 'firebase/storage';
import { collection, doc, addDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import noPicture from './images/no_picture.jpg';

const EditDish = (props) => {
    
    const pickerFilter = ['.jpg','.png','.jpeg'];
    const picturePicker = useRef(null);

    const [name, setName] = useState(props.new?'':props.dish.name);
    const [price, setPrice] = useState(props.new?'':props.dish.price);
    const [description, setDescription] = useState(props.new ? '':props.dish.description);
    const [newPicture, setNewPicture] = useState();
    const [saving, setSaving] = useState(false);

    const handlePictureChange = (e) => {
        let file = e.target.files[0];

        var reader = new FileReader();

        // Callback for read complete
        reader.onload = function(e) {
            setNewPicture(e.target.result);
        };

        // Callback for read error
        reader.onerror = function(e) {
            console.log("Error loading picture: ",e);
        };
        
        reader.readAsDataURL(file);
    }

    const save = async () => {
        let updatePack = {
            description: description,
            name: name,
            picture: props.new? 'no_picture.jpg':props.dish.picture,
            price: parseFloat(price)
        };

        if(props.new){
            if(!newPicture){
                window.alert("Debes colocar una foto");
                setSaving(false);
                return;
            }else if(name.trim() === ""){
                window.alert("Debes colocar un nombre");
                setSaving(false);
                return;
            }else if(price.toString().trim() === "" || parseFloat(price) <= 0){
                window.alert("Debes colocar un precio valido.");
                setSaving(false);
                return;
            }else if(description.trim() === ""){
                window.alert("Debes colocar una descripcion");
                setSaving(false);
                return;
            }else{
                let picture = Date.now().toString();
                
                await uploadPicture(newPicture, picture);

                const resultID = await addDoc(collection(props.eDB, `Restaurants/${props.resID}/Dishes`), updatePack);
                console.log("New Dish added", resultID);

                let modifiedList = props.dishlist.slice();
                updatePack.id = resultID.id;
                updatePack.picture = picture;
                modifiedList.push(updatePack);
                props.setDishlist(modifiedList);

                setSaving(false);
                props.close();
            }
        }else if(props.delete){
            const pictureRef = ref(props.storage, `Restaurants/${props.resID}/MenuPictures/${props.dish.picture}`);
            deleteObject(pictureRef).catch((error) => {
                console.log("Error deleting, doesn't exists?");
            });

            let modifiedList = props.dishlist.filter((dish) => {
                return dish !== props.dish;
            });

            const dishRef = doc(props.eDB, `Restaurants/${props.resID}/Dishes/${props.dish.id}`);
            await deleteDoc(dishRef);

            props.setDishlist(modifiedList);
            setSaving(false);
            props.close();
        }else{
            if(name.trim() === ""){
                window.alert("Debes colocar un nombre");
                setSaving(false);
                return;
            }else if(price.toString().trim() === "" || parseFloat(price) <= 0){
                window.alert("Debes colocar un precio valido.");
                setSaving(false);
                return;
            }else if(description.trim() === ""){
                window.alert("Debes colocar una descripcion");
                setSaving(false);
                return;
            }else{
                if(newPicture){
                    updatePack.picture = Date.now().toString();
    
                    //Update in current list
                    props.setPicture(newPicture);
                    
                    //Upload new Picture
                    await uploadPicture(newPicture, updatePack.picture);
    
                    // Delete current Picture
                    const pictureRef = ref(props.storage, `Restaurants/${props.resID}/MenuPictures/${props.dish.picture}`);
                    deleteObject(pictureRef).catch((error) => {
                        console.log("Error deleting, doesn't exists?");
                    });
                }
    
                //Update doc values
    
                if(compareDish(props.dish, updatePack)){
                    const resRef = doc(props.eDB, `Restaurants/${props.resID}/Dishes/${props.dish.id}`);
                    setDoc(resRef, updatePack, { merge: true});
    
                    let index = props.dishlist.indexOf(props.dish);
                    let modifiedList = props.dishlist.slice();
                    modifiedList[index] = {...updatePack, id: props.dish.id, picture: newPicture?newPicture:props.picture};
                    props.setDishlist(modifiedList);
                }
    
                setSaving(false);
                props.close();
            }
        }
    }

    const compareDish = (originalDish, newDish) => {
        if(originalDish.name !== newDish.name) return true;
        if(originalDish.description !== newDish.description) return true;
        if(originalDish.price !== newDish.price) return true;
        if(originalDish.picture !== newDish.picture) return true;
        return false;
    }

    const uploadPicture = async (picture, name) => {
        const stoRef = ref(props.storage, `Restaurants/${props.resID}/MenuPictures/${name}`);
        const blobFrom = await fetch(picture);
        const result = await blobFrom.blob();
        await uploadBytes(stoRef, result);
    }
    
    return (
        <>
        <div style={{position: 'relative'}}>
            <div className='EditTools'>
                    <button style={{display: newPicture ? 'none':'block'}} onClick={() => picturePicker.current.click()} className="cbtn" disabled={props.delete}><MdModeEditOutline size='1rem' pointerEvents='none'/></button>
                    <button style={{display: newPicture ? 'block':'none'}} onClick={() => {picturePicker.current.value = ''; setNewPicture(undefined);}} className="cbtn"><MdDelete size='1rem' pointerEvents='none'/></button>
                    <input className='d-none' type='file' accept={pickerFilter} ref={picturePicker} onChange={handlePictureChange} />
            </div>

            <div style={{overflow: 'hidden', textAlign: 'center', maxHeight: '45vh', borderRadius: '1rem'}} >
                <img className='dishPicture' src={newPicture ? newPicture:(props.new?noPicture:(props.picture?props.picture:noPicture))} width='100%'/>
            </div>
            <div className="mt-2">
                Nombre: <input type='text' value={name} onChange={(e) => setName(e.target.value)} disabled={props.delete}/>
            </div>
            <div className="mt-1">
                Precio: <input type='text' value={price} onChange={(e) => setPrice(e.target.value)} disabled={props.delete}/>
            </div>
            <div className="mt-1">
                Descripcion:<br/><textarea style={{width: '100%', minHeight: '80px'}} onChange={(e) => setDescription(e.target.value)} defaultValue={description} disabled={props.delete}></textarea>
            </div>

            <div className="mt-2">
                <button className={props.delete? 'm-auto btn btn-cancel':'m-auto btn btn-accept'} onClick={() => {setSaving(true);save();}} disabled={saving}>{saving?<progress></progress>:(props.delete?'Borrar':'Guardar')}</button>
            </div>
        </div>
        </>
    );
}

export default EditDish;